<div class="manage-payment-form-container">
  <div class="bolt-container">
    <bolt-progress-bar appFocusOnInit arialabel="setup automatic payments progress value is 100%" class="progress-bar-container to-container" value="100"></bolt-progress-bar>
    <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Set up automatic payments: confirmation</h1>

    <div class="bolt-row">
      <div class="bolt-col-sm-12">
        @if (successfullyEnrolled) {
          <bolt-notification class="bolt-space-bottom-2xl to-container" type="success">Your automatic payment changes have been confirmed.</bolt-notification>
          <app-payment-sub-header>Confirmation details</app-payment-sub-header>
          <div class="bolt-space-bottom-2xl">
            <ng-container>
              <div class="bolt-row">
                <div class="bolt-col">
                  <strong>{{ effectiveDateAutomatic }}</strong>
                </div>
                <div class="bolt-col">
                  {{ formattedCurrentDate }}
                </div>
              </div>
            </ng-container>
          </div>
          @if (this.amountDueExists()) {
            <app-payment-sub-header>Outstanding payment due</app-payment-sub-header>
            <p class="bolt-space-bottom-2xl">
              A payment of {{ amountDue }} for this account is due on {{ amountDueDate | date: 'MM/dd/yyyy' }}. This amount will not be automatically deducted from your account.
            </p>
          }

        } @else {
          <bolt-notification class="bolt-space-bottom-2xl to-container" type="error" id="error-notification">
            {{ enrollmentErrorMessage() }}
          </bolt-notification>
        }
      </div>
    </div>
  </div>
  @if (amountDueExists()) {
    <bolt-button-bar>
      <is-button slot="cancel" id="print-button" (click)="showPrintDialog()">Print</is-button>
      <is-button slot="back" id="secondary-button" (click)="secondayNavigation(secondaryButton)">{{ secondaryButton.label }}</is-button>
      @if (upNextLabel) {
        <is-button slot="forward" id="submit-button" [type]="solid" (click)="onContinue()">
          {{ upNextLabel }}
        </is-button>
      }
    </bolt-button-bar>
  } @else {
    <bolt-button-bar>
      <is-button slot="cancel" id="print-button" (click)="showPrintDialog()">Print</is-button>
      <is-button slot="forward" id="secondary-button" (click)="secondayNavigation(secondaryButton)">{{ secondaryButton.label }}</is-button>
    </bolt-button-bar>
  }
</div>
